import { Client, MotdEvent } from 'irc-framework';
import { IRC_EVENT, IRCMessageType } from '#/types/types';
import ConnectionHandler from '#/connectionHandler';
import TabManager from '#/ui/tabManager';
import MessageHandler from '#/messageHandler';

export class MotdEventListener {
    private cH: ConnectionHandler;
    private client: Client;
    private tM: TabManager;
    private mH: MessageHandler;

    constructor(connectionHandler: ConnectionHandler) {
        this.cH = connectionHandler as ConnectionHandler;
        this.client = connectionHandler.client as Client;
        this.tM = connectionHandler.tabManager as TabManager;
        this.mH = connectionHandler.messageHandler as MessageHandler;
        this.setup();
    }

    private setup(): void {
        this.client.on(IRC_EVENT.MOTD, (event: MotdEvent) => {
            const { motd, error, tags } = event;
            if (motd) {
                motd.split('\n').forEach((line: string) => {
                    this.mH.addMessage(this.tM.getStatusTab(), `[MOTD] ${line}`, IRCMessageType.SYSTEM);
                });
            }
        });
    }
}